<template>
  <v-app>
    <header-mobile />
    <div class="kt-grid kt-grid--hor kt-grid--root">
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
      >
        <aside-base v-if="$vuetify.breakpoint.width > 1024" />
        <div
          class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
          id="kt_wrapper"
        >
          <header-base v-if="$vuetify.breakpoint.width > 1024" />
          <!--Start of banner for client's dashboard and lms-->
          <div class="client-banner">
            <lms-intro></lms-intro>
          </div>
          <!--End of banner for client only-->

          <div
            class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
          >
            <div
              class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"
              id="router-view"
            >
              <router-view></router-view>
            </div>
          </div>
          <footer-base />
        </div>
      </div>
    </div>
    <no-access-dialog />
    <no-access-lms-dialog />
    <no-access-permission-dialog />
  </v-app>
</template>

<script>
// import AssignToolbar from '@/components/partials/AssignToolbar.vue';
import NoAccessDialog from '@/components/partials/NoAccessDialog.vue';
import NoAccessLmsDialog from '@/components/partials/NoAccessLmsDialog.vue';
import NoAccessPermissionDialog from '@/components/partials/NoAccessPermissionDialog.vue';
import AsideBase from '../components/partials/_aside/AsideBase.vue';
import HeaderBase from '../components/partials/_header/HeaderBase.vue';
import FooterBase from '../components/partials/_footer/FooterBase.vue';
import HeaderMobile from '../components/partials/_header/HeaderMobile.vue';
import LmsIntro from '../components/client-lms/LmsIntro.vue';
import CourseMenu from '@/components/partials/CourseMenu';
import ToolbarAssignModule from '@/components/partials/_toolbar/AssignModules.vue';
import ToolbarAssignPlaylist from '@/components/partials/_toolbar/AssignPlaylist.vue';
import ToolbarQrCodeDialog from '@/components/partials/_toolbar/QrCode.vue';
import AddContent from '@/components/partials/AddContent';

export default {
  name: 'Main',
  components: {
    // AssignToolbar,
    CourseMenu,
    NoAccessPermissionDialog,
    NoAccessDialog,
    AsideBase,
    HeaderBase,
    FooterBase,
    HeaderMobile,
    LmsIntro,
    AddContent,
    NoAccessLmsDialog,
  },
  data: function () {
    return {
      showAssignPlaylist: false,
      top: false,
      right: true,
      bottom: true,
      left: false,
      fab: false,
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    curriculumsReady() {
      return this.$store.state.curriculums.isCurriculumsReady;
    },
  },
  created() {
    this.fetchCurriculums();
    this.setCompanyLayout();
    this.fetchUsers();
  },
  mounted() {
    this.$store.dispatch('dealers/getDealers');
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
  methods: {
    fetchCurriculums() {
      if (!this.curriculumsReady) {
        this.isLoading = true;
        this.setCurriculums();
        this.isLoading = false;
      }
    },
    fetchUsers() {
      this.$store
        .dispatch('lmsClient/fetchUsersByDealer')
        .then(({ data }) => {
          this.$store.dispatch('lmsClient/setUsers', data);
        })
        .catch(() => {});
    },
    setCompanyLayout() {
      this.axios
        .get('/company-layouts', {
          params: {
            email: this.$auth.user().email,
          },
        })
        .then(({ data }) => {
          this.setLayout(data);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.client-banner {
  margin-top: -5px;
}
.assign-toolbar, .add-contents {
  bottom: 0px;
  margin: 10px 0px 10px 0px;
}
.assign-toolbar v-icon, .add-contents v-icon {
  color: #59400D;
}
</style>
